import { useEffect } from 'react';
import { trackEvent } from 'services/logging/appInsights';

export default function useTrackPageView(page) {
  useEffect(() => {
    const pageView = `${page}Page_Viewed`;
    trackEvent(pageView);
  }, [page]);
}
